import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName } from '../utils';

/** ユーザー出力順のキー */
enum UserOrderItem {
  userId = '1',
  mstSpareName01 = '2',
  mstSpareName02 = '3',
}

const nameConfig = {
  userId: new Map([
    [Locale.ja, 'ユーザID'],
    [Locale.en, 'User Id'],
  ]),
  mstSpareName01: new Map([
    [Locale.ja, '予備名称1'],
    [Locale.en, 'Master Spare Name One'],
  ]),
  mstSpareName02: new Map([
    [Locale.ja, '予備名称2'],
    [Locale.en, 'Master Spare Name Two'],
  ]),
};

const toDisplayWithPrefix = enumToName(UserOrderItem, nameConfig, { prefix: true });

export const userOrderItem = {
  enum: UserOrderItem,
  nameConfig,
  toDisplayWithPrefix,
};
export type { UserOrderItem };
